/*
|
|               Product
_______________________________________________
|
|    This class keep all fields for 
|    new product.
|
*/

export class Product {
    active                     :boolean = true;
    attachment                 :any    = '';
    attachment_public_id       :any    = '';
    baseType                   :string;
    basicSpec                  :string;
    bulbID                     :any;
    buyPrice                   :any;
    clone?                     :string;
    description                :string;
    entity                     :string;
    existingOrProposed         :string;
    specsPDF                   :string;
    id                         :any;
    installationCost           :number;
    lampsPerProduct?           :number;
    life                       :number;
    linkedProducts             :any[] = [];
    manufacturer               :string;
    markup                     :any;
    name                       :string = '';
    notes                      :string;
    productType                :string;
    sellPrice                  :any;
    SKU                        :string = '';
    technologyType             :string;
    wattsPerLamp?              :number;
    watts?                     :number;
    manufacturer_id            :string;
}



// WEBPACK FOOTER //
// /root/anvel/angular/classes/Product.ts